import { EventBus } from '@/services/Event.js';
import EditProfile from '@/components/user/dashboard/pages/profile/edit-profile/edit-profile.vue';

export default {
    name: 'JuniorEditProfile',
    components: {
        EditProfile
    },
    data() {
        return {
            isProcessing: true,
            juniorId: -1
        }
    },
    mounted() {
        EventBus.$emit("user-load-dashboard-card");
    }
}



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/junior/junior-registration/junior-registration.js